import {invoiceReceiptDateTime} from 'utils/formatter'
import styles from './InfoBox.css'

class InfoBox extends React.Component {
  render () {
    let {createdAt, collectedBy, paymentNo, servedBy} = this.props
    return (<div className={styles['receipt-info-box']}>
      <div className={styles['receipt-date']}>
        <div className='pull-left'>{ invoiceReceiptDateTime(createdAt, 'date') }</div>
        <div className='pull-right'>{ invoiceReceiptDateTime(createdAt, 'time') }</div>
      </div>

      <div className={styles['receipt-number']}>
        <div className='pull-left'>Receipt Number</div>
        <div className='pull-right'>{paymentNo}</div>
      </div>

      <div className={styles['receipt-served']}>
        <div className='pull-left'>Served By</div>
        <div className='pull-right'>{ servedBy }</div>
      </div>

      <div className={styles['receipt-collected']}>
        <div className='pull-left'>Collected By</div>
        <div className='pull-right'>{ collectedBy }</div>
      </div>
    </div>)
  }
}

InfoBox.propTypes = {
  servedBy: React.PropTypes.string,
  collectedBy: React.PropTypes.string,
  paymentNo: React.PropTypes.string,
  createdAt: React.PropTypes.object
}

export default InfoBox



// WEBPACK FOOTER //
// ./app/components/receipt/previews/InfoBox/InfoBox.js